import { render, staticRenderFns } from "./QuoteCarousel.vue?vue&type=template&id=18b0038c&scoped=true"
import script from "./QuoteCarousel.vue?vue&type=script&lang=js"
export * from "./QuoteCarousel.vue?vue&type=script&lang=js"
import style0 from "./QuoteCarousel.vue?vue&type=style&index=0&id=18b0038c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b0038c",
  null
  
)

export default component.exports